module.exports = __webpack_public_path__ + "static/img/course03.8facc7e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/course03.jpg
// module id = tzYh
// module chunks = 101